import { render, staticRenderFns } from "./StudentCard.vue?vue&type=template&id=924fec74&scoped=true&"
import script from "./StudentCard.vue?vue&type=script&lang=js&"
export * from "./StudentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924fec74",
  null
  
)

export default component.exports